<template>
    <div>

      <div style="padding:1rem 0;font-weight:bold;font-size:1.5rem;">临时收费</div> 
      <div>
        收费标准
        <el-select 
        v-model="tempSubjectId"
        @change="tempSubjectIdChange"
        >
                    <el-option
                        v-for="item in tempSubjectList"
                        :key="item"
                        :value="item.id"
                        :label="item.name"
                    >
                    </el-option>
        </el-select>
        <el-input style="width:6rem;margin:0 .5rem;" v-model="tempPrice"></el-input>
        <el-button size="small" type="primary" @click="addTableData">加入临时收费</el-button>
      </div>
      <div>
        <div style="padding-top:2rem;">临时费用预览</div>
        <el-table :data="tableData">
          <el-table-column
                type="index"
                label="序号">
                
          </el-table-column>
          <el-table-column
                prop="name"
                label="收费标准"></el-table-column>
          <el-table-column
                prop="feePrice"
                label="单价">
                 <template slot-scope="scope">
                   <div>{{scope.row.feePrice}}</div>
                </template></el-table-column>
          <el-table-column
                prop="feeNumber"
                label="数量">
                <template slot-scope="scope">
                  <!-- <div v-if="parseInt(scope.row.pricingModel)==4">
                    {{scope.row.feeNumber}}
                  </div>
                  <div v-else> -->
                    <el-input v-model="scope.row.feeNumber"
                     type="text"
                     maxlength='7' 
                     @input="(e)=>{accountNumberChange(e,scope)}"></el-input>
                  <!-- </div> -->
                </template>
          </el-table-column>
          <el-table-column
                prop="payPrice"
                label="收费金额">
                <template slot-scope="scope">
                  <div v-if="parseInt(scope.row.pricingModel)==4">
                    <el-input v-model="scope.row.payPrice"></el-input>
                  </div>
                  <div v-else>{{scope.row.feeNumber*scope.row.feePrice}}</div>
                </template>
          </el-table-column>
          <el-table-column
                prop="startTime"
                width="280"
                label="开始日期">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.startTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </template>
          </el-table-column>
          <el-table-column
                prop="endTime"
                width="280"
                label="结束日期">
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.endTime"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </template>      
          </el-table-column>
          <el-table-column
                prop="payPrice"
                label="本次应收"></el-table-column>
          <el-table-column
                prop="edit"
                label="操作">
                <template slot-scope="scope">
                <el-button @click="removeActionHandler(scope)" size="small">
                  移出
                </el-button>
                </template>
          </el-table-column>
        </el-table>
      </div>
        <div style="padding-top:2rem;">费用合计:{{totalPrice}}</div>
        <div style="text-align:right">
          <el-button type="primary" @click="payBillAction">
            收费
          </el-button>
        </div>


        <el-dialog title="收款信息" append-to-body :visible.sync="billPayBoxFlag">
            <div style="display:flex;text-align:center;padding-bottom:1rem;">
                <div style="flex:1">房间:{{communityName}}</div>
                <div style="flex:1">客户：{{payManName}}</div>
                <div style="flex:1">费用合计：{{totalCalAmount}}元</div>
            </div>
            <avue-form
                ref="billPayForm"
                v-if="billPayBoxFlag"
                :option="billPayFormOption"
                v-model="billPayForm"
            >
                
                <template slot="authCode">
                    <!-- v-if="showAuthCodeFlag" -->
                    <el-input type="password" ref="authCodeInput" v-model="billPayForm.authCode" @blur="blurHandler" @input="inputHandler" @focus="focusHandler" maxlength="18" placeholder="请输入付款码"></el-input>
                </template>
                <template slot="payType">
                    <el-select 
                        v-model="billPayForm.payType"
                        @change="payTypeChange"
                    >
                        <el-option
                            v-for="item in payTypeList"
                            :key="item"
                            :value="item.dictKey"
                            :label="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </template>

                <template slot="payScene">
                    <el-select 
                        v-model="billPayForm.payScene"
                        @change="paySceneChange"
                    >
                        <el-option
                            v-for="item in paySceneList"
                            :key="item"
                            :value="item.dictKey"
                            :label="item.dictValue"
                        >
                        </el-option>
                    </el-select>
                </template>


            </avue-form>
            <div style="padding:1rem;overflow:hidden;">
                <div style="float:right;">
                    <el-button @click="confirmPayAction" type="primary">确认收款</el-button>
                    <el-button @click="cancelPay" type="normal">取消</el-button>
                </div>
            </div>
            
        </el-dialog>

            <el-dialog
                :title="payScene==6?'查询中':'收款码'"
                :visible.sync="payInfo2.showQrCode"
                :close-on-click-modal="false"
                width="30%"
                top="16vh"
                append-to-body
                @close="closeQrCode"
            >
                <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
                    {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
                </div>
                <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
                    扫码支付后请勿手动关闭弹窗
                </div>
                <div style="text-align: center">
                    <div id="qrcodeTempFeeNew" ref="qrcode" style="display: inline-block"></div>
                    <div>倒计时：{{ payInfo2.countdown }}</div>
                </div>
            </el-dialog>

            <printPreview ref="printPreview"></printPreview>

    </div>
</template>

  <script>
  import {
        getStandardByTargetId,
        getPayTypeList,
        getPaySceneList,
        saveQrCodePayTemp,
        loadPayStatusChannel,
        loadPayStatusPlatform,
    } from '@/api/charge/charge-pay';
import QRCode from 'qrcodejs2';
import dayjs from 'dayjs';
    import {mapGetters, mapState} from "vuex";
    import printPreview from '@/views/v4ward/pay/printdialog-v2/printPreview';
    export default {
        components: { printPreview },
        props: ['targetId'],
      data() {
        return {
            payInfo:{
                payBillNo:''
            },
            payInfo2:{
                timer:'',
                showQrCode:false,
                countdown:'',
                tradeStatus:'',
            },
          tableData: [],
          tempSubjectList:[],
          tempSubjectId:'',
          tempPrice:'',
          tempFeeObject:'',
          totalPrice:0,
          billPayBoxFlag:false,
          billPayForm:{},
          payTypeList:[],
          paySceneList:[]
        }
      },
      
    computed: {
        ...mapGetters(["tagList"]),
        
       billPayFormOption(){
         return{
            menuBtn:false,
            column: [
                      {
                        label: "应收金额",
                        prop: "shouldPayMoney",
                        type:'input',
                        disabled: true
                      },
                      {
                        label: "实收金额",
                        prop: "confirmPayMoney",
                        type:'input',
                        disabled: true
                      },
                      {
                        label: "收款方式",
                        prop: "payType",
                        formslot:true,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择收款方式",
                            trigger: "blur"
                        }],
                    },{
                        label: "收款类型",
                        prop: "payScene",
                        formslot:true,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请选择收款类型",
                            trigger: "blur"
                        }],
                    },{
                        label: "付款码",
                        prop: "authCode",
                        formslot:true,
                        display:false,
                        span: 12,
                        maxlength: 3,
                        rules: [{
                            required: true,
                            message: "请输入付款码",
                            trigger: "blur"
                        }],
                    },{
                        label: "收款备注",
                        prop: "description",
                        span: 24,
                        type: "textarea",
                    },]
            }
        }
    },
      methods:{
        //生成二维码
            genearateQrCode() {
                this.$refs.billPayForm.validate((valid) => {
                    if (valid) {
                        this.getBillFormData();

                        if(parseInt(this.payScene)==5){
                            this.qrCodePay();
                        }else if(parseInt(this.payScene)==6){
                            this.authCodePay();
                        }else{
                            this.normalPay();
                        }
                    }
                });
            },
            //打印预览
            printprev() {
                if (
                    this.payInfo.payBillNo != ''
                    // &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1)
                ) {
                    this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
                } else {
                    this.$message.warning('请先完成收款');
                }
            },
            
        openTag(item) {
            let tag;
            if (item.name) {
            tag = this.findTag(item.name).tag;
            } else {
            tag = item;
            }
        if (tag.query.src === undefined || tag.query.src === 'undefined') {
            tag.query = {};
        }
            this.$router.push({
            path: this.$router.$avueRouter.getPath({
                name: tag.label,
                src: tag.value
            }, tag.meta),
            query: tag.query
            });
        },
        findTag(value) {
            let tag, key;
            this.tagList.map((item, index) => {
            if (item.value === value) {
                tag = item;
                key = index;
            }
            });
            return {tag: tag, key: key};
        },
            qrCodePay(){
                
                        saveQrCodePayTemp(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            this.payInfo2.showQrCode = true;
                            this.payInfo.payBillNo = data.payNo;
                            console.log("saveQrCodePayTemp========>",data);
                            this.$nextTick(() => {
                                new QRCode('qrcodeTempFeeNew', {
                                width: 250,
                                height: 250,
                                text: data.qrCodeUrl,
                                });
                            });
                            this.payInfo2.showQrCode = true;
                            this.payInfo2.countdown = 120;
                            this.payInfo2.timer = setInterval(() => {
                                if (this.payInfo2.countdown === 0) {
                                    clearInterval(this.payInfo2.timer);
                                    this.payInfo2.showQrCode = false;
                                    this.$message.info('倒计时结束，二维码弹窗关闭');
                                    
                                    this.$confirm('收费失败，请手动确认缴费状态！', '提示', {
                                        confirmButtonText: '更新账单',
                                        cancelButtonText: '取消',
                                        type: 'warning'
                                    }).then(() => {
                                        // this.$message({
                                        //     type: 'success',
                                        //     message: '删除成功!'
                                        // });
                                        // this.printprev()
                                        let {tag, key} = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                                        this.$store.commit("DEL_TAG", tag);
                                        this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal`});
                                    }).catch(() => {
                                        // this.$message({
                                        //     type: 'info',
                                        //     message: '已取消删除'
                                        // });     
                                        //重置数据
                                        this.resetAllData();    
                                    });

                                    // this.resetAllData();
                                    // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});

                                }
                                if (this.payInfo2.countdown % 5 === 0) {
                                    loadPayStatusPlatform({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                                        this.payInfo2.tradeStatus = data.payStatus;
                                        if (parseInt(data.payStatus) == 1) {
                                            this.payInfo2.showQrCode = false;
                                            this.$message.success('支付成功');
                                            this.isSuccess = true;
                                            clearInterval(this.payInfo2.timer);


                                            this.$confirm('收费成功，是否需要打印收据？', '提示', {
                                                confirmButtonText: '打印',
                                                cancelButtonText: '取消',
                                                type: 'warning'
                                            }).then(() => {
                                                // this.$message({
                                                //     type: 'success',
                                                //     message: '删除成功!'
                                                // });
                                                //重置数据
                                                this.resetAllData();    
                                                this.printprev()
                                            }).catch(() => {
                                                // this.$message({
                                                //     type: 'info',
                                                //     message: '已取消删除'
                                                // });     
                                                //重置数据
                                                this.resetAllData();    
                                            });
                                            // this.submitAllBill();
                                        }
                                    });
                                }
                                this.payInfo2.countdown--;
                            }, 1000);
                            }
                        );
            },
            authCodePay(){
                
                        saveQrCodePayTemp(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            // this.payInfo2.showQrCode = true;
                            this.payInfo.payBillNo = data.payNo;
                            this.payInfo2.showQrCode = true;
                            this.payInfo2.countdown = 120;
                            this.payInfo2.timer = setInterval(() => {
                                if (this.payInfo2.countdown === 0) {
                                    clearInterval(this.payInfo2.timer);
                                    this.payInfo2.showQrCode = false;
                                    this.$message.info('倒计时结束，二维码弹窗关闭');
                                    // this.resetAllData();
                                    let {tag, key} = this.findTag('/v4ward/fundpay/fundpay-abnormal');
                                    this.$store.commit("DEL_TAG", tag);
                                    this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal`});
                                    // this.$router.push({path: `/v4ward/fundpay/fundpay-abnormal?payNo=${data.payNo}&resourceType=1`});
                                }
                                if (this.payInfo2.countdown % 5 === 0) {
                                loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                                    this.payInfo2.tradeStatus = data.payStatus;
                                    if (parseInt(data.payStatus) == 1) {
                                    this.payInfo2.showQrCode = false;
                                    this.$message.success('支付成功');
                                    this.isSuccess = true;
                                    clearInterval(this.payInfo2.timer);
                                    
                                            this.$confirm('收费成功，是否需要打印收据？', '提示', {
                                                confirmButtonText: '打印',
                                                cancelButtonText: '取消',
                                                type: 'warning'
                                            }).then(() => {
                                                // this.$message({
                                                //     type: 'success',
                                                //     message: '删除成功!'
                                                // });
                                                //重置数据
                                                this.resetAllData();    
                                                this.printprev()
                                            }).catch(() => {
                                                // this.$message({
                                                //     type: 'info',
                                                //     message: '已取消删除'
                                                // });     
                                                //重置数据
                                                this.resetAllData();    
                                            });
                                    //重置数据
                                    // this.resetAllData();
                                    // this.submitAllBill();
                                    }
                                });
                                }
                                this.payInfo2.countdown--;
                            }, 1000);
                            }
                        );
            },
            
            normalPay(){
                        saveQrCodePayTemp(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
                            ({ data }) => {
                            this.payInfo.payBillNo = data.payNo;
                                loadPayStatusChannel({ payNo: this.payInfo.payBillNo }).then(({ data }) => {
                                    this.payInfo2.tradeStatus = data.payStatus;
                                    if (parseInt(data.payStatus) == 1) {
                                    this.$message.success('支付成功');

                                    
                                            this.$confirm('收费成功，是否需要打印收据？', '提示', {
                                                confirmButtonText: '打印',
                                                cancelButtonText: '取消',
                                                type: 'warning'
                                            }).then(() => {
                                                // this.$message({
                                                //     type: 'success',
                                                //     message: '删除成功!'
                                                // });
                                                //重置数据
                                                this.resetAllData();    
                                                this.printprev()
                                            }).catch(() => {
                                                // this.$message({
                                                //     type: 'info',
                                                //     message: '已取消删除'
                                                // });     
                                                //重置数据
                                                this.resetAllData();    
                                            });
                                    //重置数据
                                    // this.resetAllData();
                                    // this.submitAllBill();
                                    }
                                });
                            }
                        );
            },
            //关闭二维码
            closeQrCode() {
            setTimeout(() => {
                this.$refs.qrcode.innerHTML = '';
            }, 300);
                clearInterval(this.payInfo2.timer);
            },
            resetAllData(){
                // location.reload();
                this.billPayForm = {};
                this.tableData = [];
                this.billPayBoxFlag = false;
            },
            confirmPayAction(){
                this.genearateQrCode()
            },
          cancelPay(){
              this.billPayBoxFlag = false;
          },
            getBillFormData(){
                
                        console.log(this.payBillList);
                        this.payScene = this.billPayForm.payScene
                        let payScene = this.payScene;
                        let payType = this.billPayForm.payType
                        let authCode = this.billPayForm.authCode||'';

                        let payList = [];
                        let communityId = '';
                        let targetId = '';
                        let totalCalAmount = 0;
                        let payManName = '';
                        let self = this;
                        this.tableData.forEach((ele,index)=>{
                            communityId = ele.communityId;
                            targetId = self.targetId;
                            payManName = self.payManName;
                            totalCalAmount = self.totalCalAmount;
                            payList.push({
                                subjectId:ele.subjectId,
                                standardId:ele.id,
                                // linkId:ele.id,
                                calAmount:ele.payPrice,
                                shouldAmount:ele.payPrice,
                                isDiscount:'0',
                                startDate:dayjs(ele.startTime).format('YYYY-MM-DD 00:00:00'),
                                endDate:dayjs(ele.endTime).format('YYYY-MM-DD 00:00:00'),
                                // billcycleNo:ele.billcycleNo,
                                payDetail:JSON.stringify(ele),
                                description:'description',
                            });
                        })

                        totalCalAmount = Math.round(totalCalAmount*100)/100;
                        this.payParams = {
                          description:self.billPayForm.description,
                                            authCode: authCode,
                                            communityId: communityId,
                                            payScene: payScene,
                                            payType: payType,
                                            totalCalAmount: totalCalAmount,
                                            totalShouldAmount: totalCalAmount,
                                            totalDelayAmount: 0,
                                            totalDerateAmount: 0,
                                            totalAccountpayAmount: 0,
                                            totalCouponAmount: 0,
                                            payManName: payManName,
                                            targetId: targetId,
                                            resourceType: 1,
                                            payCost: 1,
                                            payList: payList
                                        }
                                        console.log(this.payParams);
            },
          paySceneChange(val){
              console.log(this.$refs.billPayForm);
              if(parseInt(val)==6){
                  this.showAuthCodeFlag = true;
                  this.$refs.billPayForm.columnOption[0].column[4].display=true;
              }else{
                  this.showAuthCodeFlag = false;
                  this.$refs.billPayForm.columnOption[0].column[4].display=false;
              }
          },
            payTypeChange(val){
                if(val){
                    this.billPayForm.payScene = '';
                    if(parseInt(val)==1){
                        this.$refs.billPayForm.columnOption[0].column[4].display=false;
                        this.showAuthCodeFlag = false;
                        this.$refs.billPayForm.columnOption[0].column[3].display=false;
                    }else{
                        this.showAuthCodeFlag = true;
                        this.$refs.billPayForm.columnOption[0].column[3].display=true;
                    }
                    getPaySceneList({payType:val}).then((res)=>{
                        this.paySceneList = res.data;
                        console.log(res);
                    });
                }
            },
        payBillAction(){
          if(this.tableData.length>0){
            this.totalCalAmount = this.totalPrice;
            this.billPayBoxFlag = true;
            this.billPayForm.shouldPayMoney = this.totalPrice;
            this.billPayForm.confirmPayMoney = this.totalPrice;
            getPayTypeList().then((res)=>{
              
                  console.log(res);
                  this.payTypeList = res.data;


                  
            // this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
            })

          }else{
            this.$message.error('请选择账单数据!');
          }
        },
        calculateTotalPrice(){
          let total = 0;
          if(this.tableData.length>0){
            this.tableData.forEach((ele)=>{
              total += parseFloat(ele.payPrice);
            });
          }else{
            total = 0;
          }
          this.totalPrice = total.toFixed(2);
        },
        removeActionHandler(scope){
          console.log();
          this.tableData.splice(scope.$index, 1);
          setTimeout(()=>{
            this.calculateTotalPrice();
          });
        },
        outNumber(e,max=9999.99){
                        let value = e;
                        value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
                        value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                        value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
                        if (value.indexOf(".") < 0 && value != "") {
                                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                                value = parseFloat(value);
                        }
                        value = String(value);
                        if(value.indexOf('.')==4){
                                value=value.slice(0,8)
                        }
                        else if(value.indexOf('.')==2){
                             value=value.slice(0,6)
                        }
                        else{
                            value = value.slice(0,4)
                        }
                        if(value=='.'){
                                value = '0.'
                        }

                        return value;
                },
        accountNumberChange(e,scope){
          scope.row.feeNumber=this.outNumber(e);
          this.tableData[0].payPrice = this.tableData[0].feeNumber* this.tableData[0].feePrice
          this.totalPrice=this.tableData[0].payPrice
          console.log(this.tableData[0])
          // console.log(scope.row.account,scope,'$$$$$$$$$$$$');
          // console.log(val,row,scope);
          // if(val===''){
          //   val = 0;
          // }
          // if((Number(val)+'')==='NaN'){
          //   val = 1;
          //   this.$message.error('请输入数字!');
          //   // setTimeout(()=>{
          //     this.tableData[scope.$index].feeNumber = 1;
          //   // });
          // }
          // this.tableData[scope.$index].payPrice = (parseInt(val)*row.feePrice).toFixed(2);
          // setTimeout(()=>{
          //   this.calculateTotalPrice();
          // });
        },
        addTableData(){
          if(!this.tempPrice){
            this.$message.error('请选择收费标准！');
            return;
          }
          let self = this;
          console.log();
          let startDay = dayjs().startOf('month');
          let endDay = dayjs().endOf('month');
          let obj = {
            ...self.tempFeeObject,
            feeNumber:1,
            payPrice:self.tempFeeObject.feePrice,
            startTime:dayjs(startDay).toDate(),
            endTime:dayjs(endDay).toDate(),
          };
          let isRepeat = false;
          let isRepeatIndex = '';
            this.tableData.forEach((ele,index)=>{
              if(ele.id === self.tempFeeObject.id){
                isRepeat = true;
                isRepeatIndex = index;
              }
            });
          if(isRepeat){
            this.tableData[isRepeatIndex].feeNumber = this.tableData[isRepeatIndex].feeNumber + 1;
            this.tableData[isRepeatIndex].payPrice = parseFloat(parseFloat(self.tempFeeObject.feePrice)*this.tableData[isRepeatIndex].feeNumber).toFixed(2);
          }else{
            this.tableData.push(obj);
            console.log(this.tableData);
          }
          setTimeout(()=>{
            this.calculateTotalPrice();
          });
        },
        tempSubjectIdChange(val){
          this.tempSubjectList.forEach((ele,index)=>{
            if(val===ele.id){
              this.tempPrice = ele.feePrice;
              this.tempFeeObject = ele;
            }
          });
        },
          getSubjectListHandler(val,name,householderName){
            // console.log(this.targetId);
            this.tableData = [];
            this.communityName = name;
            this.payManName = householderName;
            this.tempSubjectId = '';
            this.tempFeeObject = '';
            this.tempPrice = '';
            setTimeout(()=>{
              this.calculateTotalPrice();
            });
            getStandardByTargetId({cycleType:2,targetId:val}).then((res)=>{
                console.log(res);
                this.tempSubjectList = res.data;
                console.log(this.tempSubjectList);
                setTimeout(()=>{
                  this.tempSubjectId = this.tempSubjectList[0].id;
                  this.tempPrice = this.tempSubjectList[0].feePrice;
                  this.tempFeeObject = this.tempSubjectList[0];
                })
            })
          },
      }
    }
  </script>

<style>

</style>